import {
    getDownloadURL,
    ref as storageRef,
    uploadBytes,
    deleteObject,
} from 'firebase/storage';
import { DevicePictureTypeId } from 'types';
import { firebaseStorage } from 'lib/firebase';

/**
 * Uploads a picture from a given reference path to firebase storage
 * @param {string} supplierId - supplierId associated with image ref path
 * @param {string} deviceId - device id associated with image ref path
 * @param {DevicePictureTypeId} pictureTypeId - picture type id associated with image ref path
 * @param {Blob} picture - blob to be uploaded
 * @returns url, path
 */
export const uploadPicture = async (
    supplierId: string,
    deviceId: string,
    // 1 is sitePicture, 0 is gauge picture
    pictureTypeId: DevicePictureTypeId,
    picture: Blob
) => {
    const date = new Date();

    const path = `/deployment_pictures/${supplierId}/${deviceId}/${pictureTypeId}${date}.png`;

    const deploymentPictureRef = storageRef(firebaseStorage, path);

    return await uploadBytes(deploymentPictureRef, picture).then(
        async (res) => {
            const url = await getDownloadURL(res.ref);
            return { url, path: res.ref.fullPath };
        }
    );
};

/**
 * Removes a picture from a given reference path to firebase storage
 * @param {string} picturePath - path of location of image url in firebase storage
 * @returns void
 */
export const removePicture = async (picturePath: string) => {
    const deploymentPictureRef = storageRef(firebaseStorage, picturePath);

    return await deleteObject(deploymentPictureRef);
};
